import { ObjectTools } from '../../../tools/object-tools';
import { SolIcon } from '@sol/icons';
import { SolShortcut } from '../../../services/shortcut.service';
import { SolButtonType } from '../../../models/core/sol-button';

export interface SolMenuGroup {
  name?: string;
  items: SolMenuItem[];
}

export interface SolMenuItem {
  id: string;
  name?: string;
  params?: Record<string, any>;
  icon?: SolIcon;
  hint?: string;
  disabled?: boolean;
  selected?: boolean;
  priority?: SolMenuPriority;
  shortcut?: SolShortcut;
  type?: SolButtonType;
}

export type SolMenuPriority = 'primary' | 'secondary' | 'default';

export class SolPopoverMenuContentState {
  private constructor(
    public readonly menu: SolMenuGroup[],
    public readonly shortcutsEnabled: boolean,
    public readonly currentId: string,
    public readonly hostClass: string,
    public readonly visibleGroups: SolMenuGroup[],
    public readonly passive: boolean,
  ) {}

  public static of(): SolPopoverMenuContentState {
    return new SolPopoverMenuContentState([], false, '', '', [], false).recalculate();
  }

  public withPassive(passive: boolean): SolPopoverMenuContentState {
    if (this.passive === passive) return this;
    return this.copy({ passive });
  }

  public withMenu(menu: SolMenuGroup[]): SolPopoverMenuContentState {
    return this.copy({ menu }).recalculate();
  }

  public withShortcutsEnabled(shortcutsEnabled: boolean): SolPopoverMenuContentState {
    return this.copy({ shortcutsEnabled });
  }

  public withCurrentId(currentId: string): SolPopoverMenuContentState {
    return this.copy({ currentId });
  }

  private recalculate(): SolPopoverMenuContentState {
    const hasIcons = this.menu.some(group => group.items.some(item => !!item.icon));
    const hostClass = hasIcons ? 'sol-popover-menu-items' : 'sol-popover-menu-items sol-popover-menu-items-no-icons';
    const visibleGroups = this.menu.filter(group => group.items.length > 0);
    return this.copy({ hostClass, visibleGroups });
  }

  private copy(props: Partial<SolPopoverMenuContentState>): SolPopoverMenuContentState {
    return ObjectTools.copy<SolPopoverMenuContentState>(this, props);
  }
}
